/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  getTheme,
  IButtonStyles,
  IStackItemStyles,
  IStackStyles,
  IStackTokens,
  ITextStyles,
} from "@fluentui/react";

const theme = getTheme();

/**
 * The stack containing all of the form elements.
 */
export const containerStyles: IStackStyles = {
  root: {
    alignItems: "center",
    marginBottom: "1rem",
    padding: "1.5rem",
    backgroundColor: theme.semanticColors.listItemBackgroundHovered,
    borderRadius: "8px",
    height: "100%",
  },
};

export const stackRoleStyles: IStackItemStyles = {
  root: {
    alignItems: "left",
    display: "flex",
    justifyContent: "left",
    textTransform: "capitalize",
    width: "20%",
  },
};

export const stackRoleDetailsStyles: IStackItemStyles = {
  root: {
    alignItems: "left",
    display: "flex",
    justifyContent: "left",
    textTransform: "capitalize",
    width: "50%",
  },
};

export const horizontalGapStackTokens: IStackTokens = {
  childrenGap: 10,
  padding: 10,
};

export const buttonStyles: IButtonStyles = {
  root: {
    marginRight: 8,
  },
};

/**
 * Delete button styles
 */
export const deleteButtonStyles: IButtonStyles = {
  root: {
    border: `1px solid ${theme.palette.red}`,
    backgroundColor: theme.palette.red,
    color: theme.palette.white,
  },
  rootHovered: {
    backgroundColor: theme.palette.redDark,
    color: theme.palette.white,
  },
  rootPressed: {
    backgroundColor: theme.palette.red,
    color: theme.palette.white,
  },
};

export const textStyles: ITextStyles = {
  root: {
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "22px",
  },
};
